<template>
  <base-modal-ex v-if="$userInfo"
    :active.sync="isActive"
    :animation-in="animationIn"
    :animation-out="animationOut"
    :animation-duration="animationDuration"
    :can-cancel="true"
    @update:active="close()">
    <div class="box">
      <article class="media">
        <div class="media-content">
          <img src="@/assets/images/flexiquote-logo.svg"
            style="max-height: 5rem">
          <div class="content">
            Version: {{ version }}<br>
            Commit Hash: {{ commitHash }}<br>
            Build Date: {{ timeStamp | formatDateTimeLocale($userInfo.locale) }}<br>
            Instance Name: {{ instanceName }}
            <div class="is-divider" />
            <span>Licence Expiry: {{ expiryDate }}</span>
            <div class="is-divider" />
            <div class="field is-grouped is-grouped-multiline ">
              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">nodejs</span>
                  <span class="tag is-primary">{{ nodeVersion }}</span>
                </div>
              </div>
              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">npm</span>
                  <span class="tag is-gold">{{ npmVersion }}</span>
                </div>
              </div>
              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">vuejs</span>
                  <span class="tag is-success">{{ vueVersion }}</span>
                </div>
              </div>
              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">bulma</span>
                  <span class="tag is-turquoise">{{ bulmaVersion }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </base-modal-ex>
</template>

<script>
import BaseModalEx from './BaseModalEx'
import { DateTimeFiltersMixin } from '@/components/mixins/filters'
import FqApi from '@/services/fq-api'

export default {
  name: 'About',
  components: {
    BaseModalEx
  },
  mixins: [DateTimeFiltersMixin],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    animationIn: {
      type: String,
      default: 'zoomIn'
    },
    animationOut: {
      type: String,
      default: 'zoomOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    },
    expiryDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isActive: this.active || false,
      version: '',
      commitHash: '',
      timeStamp: null,
      nodeVersion: '',
      npmVersion: '',
      vueVersion: '',
      bulmaVersion: '',
      instanceName: ''
    }
  },
  computed: {},
  watch: {
    active(value) {
      this.isActive = value
    }
  },
  created() {
    this.timeStamp = new Date(process.env.VUE_APP_BUILD_TIMESTAMP)
    this.version = process.env.VUE_APP_VERSION
    this.commitHash = process.env.VUE_APP_COMMIT_HASH
    this.nodeVersion = process.env.VUE_APP_NODE_VERSION
    this.npmVersion = process.env.VUE_APP_NPM_VERSION
    this.vueVersion = process.env.VUE_APP_VUE_VERSION
    this.bulmaVersion = process.env.VUE_APP_BULMA_VERSION
    this.getInstanceName()
    // console.log(
    //   `Version: ${process.env.VUE_APP_VERSION} Build: ${process.env.VUE_APP_COMMIT_HASH} (${this.timeStamp.toLocaleDateString('en-AU')} ${this.timeStamp.toLocaleTimeString()})`
    // )
  },
  mounted() {},
  methods: {
    async getInstanceName() {
      const url = 'settings/instance/name'
      const result = await FqApi.get(url)
      this.instanceName = result.data
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
div.media-content {
  overflow: hidden;
}
.is-divider {
  margin: 1.2em 0;
}
</style>
